// Position-slot helpers for Custom Booth Item links — same shape/semantics as
// PortalShared.jsx's position helpers, kept as its own small file (rather than
// literally reusing PortalShared's) so field names read as "link", not "portalLink".

export const emptyPosition = () => ({
  link: "",
  thumbnailLocalizations: [{ localeId: "en_us", mediaLink: "" }],
});

// True if the position has ANY content (link OR thumbnail).
export const positionHasContent = (position) =>
  !!position?.link || position?.thumbnailLocalizations?.some((t) => (t.mediaLink ?? '').trim());

// True only when BOTH link AND at least one thumbnail URL are filled.
export const positionIsComplete = (position) =>
  !!(position?.link ?? '').trim() &&
  !!(position?.thumbnailLocalizations?.some((t) => (t.mediaLink ?? '').trim()));

// True when one field is filled but the other is missing — partial positions are
// invalid, the user must either complete or clear them (same rule Portal enforces).
export const positionIsPartial = (position) =>
  positionHasContent(position) && !positionIsComplete(position);
